<template>
  <div class="card mb-25 border-0 rounded-0  letter-spacing lead-info-box">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
      <div class="profile-info d-flex align-items-center">
        <img src="@/assets/images/head.jpg" class="rounded" alt="user" />
        <div class="title mt-12 mt-sm-0 ms-20">
          <h5 class=" fw-medium mb-8"> {{ userInfo.name }}</h5>
          <span class="d-block fs-md-15 fs-lg-16 text-dark-emphasis mb-8">
            尊贵VIP会员
          </span>
          <span class="d-block fw-bold text-primary">会员生效中</span>
        </div>
      </div>
      <div class="border-top mt-15 mb-15 mt-sm-20 mb-sm-20 mt-md-25 mb-md-25 mt-lg-30 mb-lg-30"></div>
      <div class="d-flex align-items-center justify-content-between">
        <h5 class="fw-medium  mb-0">会员信息</h5>
        <!-- <router-link
            to="/profile-settings"
            class="d-inline-block text-decoration-none lh-1 text-muted fw-medium"
          >
            <i
              class="ph-duotone ph-pencil  position-relative top-1 fs-16 me-1"
            ></i>
            Edit
          </router-link> -->
      </div>
      <ul class="info mt-25 ps-0 mb-0 list-unstyled">
        <li class="position-relative">
          <div class="icon text-success rounded-circle text-center ">
            <feather-icon icon="UserIcon" size="25" class="mt-10"/>
          </div>
          <span class="d-block  mb-5 fw-semibold">
            登录账号
          </span>
          <span class="d-inline-block fs-md-15 fs-lg-16 text-muted">
            {{ userInfo.login }}
          </span>
        </li>
        <li class="position-relative">
          <div class="icon text-primary rounded-circle text-center ">
            <feather-icon icon="InboxIcon" size="25" class="mt-10"/>
          </div>
          <span class="d-block  mb-5 fw-semibold">电子邮箱</span>
          <a href="javaScript:void(0);" class="d-inline-block fs-md-15 fs-lg-16 text-primary text-decoration-none">
            {{ userInfo.email }}
          </a>
        </li>
        <li class="position-relative">
          <div class="icon text-warning rounded-circle text-center ">
            <feather-icon icon="AwardIcon" size="22" class="mt-12"/>
          </div>
          <span class="d-block  mb-5 fw-semibold">会员类型</span>
          <a href="javaScript:void(0);" class="d-inline-block fs-md-15 fs-lg-16 text-muted text-decoration-none">
            {{ userInfo.registerType }}
          </a>
        </li>
        <li class="position-relative">
          <div class="icon text-danger rounded-circle text-center ">
            <feather-icon icon="CalendarIcon" size="23" class="mt-11"/>
          </div>
          <span class="d-block  mb-5 fw-semibold">到期日期</span>
          <a href="javaScript:void(0);" class="d-inline-block fs-md-15 fs-lg-16 text-muted text-decoration-none">
            {{ userInfo.endDateStr }}
          </a>
        </li>

      </ul>
    </div>
  </div>
</template>

<script>

export default {
  name: "UserInfo",

  props: {
    userInfo: {
      type: Object, // 指定props的类型为Array  
      default: () => { } // 提供一个默认值，以防父组件没有传递该prop  
    }
  },

  methods: {

  }
};
</script>